<template>
  <div class="main">
    <div class="router">
      <div class="card">
        <div class="card-header">
          <el-breadcrumb>
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>医生管理</el-breadcrumb-item>
            <el-breadcrumb-item>医生列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!--添加-->
        <div class="create">
          <el-button type="primary" icon="el-icon-edit" @click="create"
            >添加</el-button
          >
          <span>共有数据: {{ total }} 条</span>
        </div>
        <!--数据-->
        <div class="card-body text">
          <el-table :data="data" style="width: 100%">
            <el-table-column prop="id" label="用户ID"> </el-table-column>
            <el-table-column prop="username" label="姓名"> </el-table-column>
            <el-table-column prop="phone" label="登录账号"> </el-table-column>
            <el-table-column prop="is_super" label="超管"> 
              <template slot-scope="scope">
                <span v-if="scope.row.is_super == 1" style="color: #f80003;">是</span>
                <span v-else>否</span>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="患者数量"> </el-table-column>
            <el-table-column label="修改密码">
              <template slot-scope="scope">
                <span
                  style="font-size: 12px; color: #f80003; cursor: pointer"
                  title="修改密码"
                  @click="change(scope.row.id)"
                  >*****</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="启用时间">
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status"
                  style="color: teal"
                  type="text"
                  size="small"
                  @click="
                    open_stop(scope.row.status, scope.row.id, scope.$index)
                  "
                >
                  停用
                </el-button>
                <el-button
                  v-else
                  style="color: #f56c6c"
                  type="text"
                  size="small"
                  @click="
                    open_stop(scope.row.status, scope.row.id, scope.$index)
                  "
                >
                  启用
                </el-button>
                <el-button
                  style="color: #409eff"
                  type="text"
                  size="small"
                  @click="openEdit(scope.row.id)"
                >
                  编辑
                </el-button>
                <el-button
                  style="color: #f56c6c"
                  @click="del(scope.row.id, scope.$index)"
                  type="text"
                  size="small"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--分页-->
      <div class="page">
        <el-pagination
          background
          :page-size="pageSize"
          layout="prev, pager, next"
          @current-change="handle_page"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        password: { new: '', old: '' },
        data: [],
        page: 1,
        pageSize: 20,
        total: 0,
      }
    },
    created() {
      this._request()
    },
    methods: {
      _request() {
        this.$request(`/member?page=${this.page}`).then((res) => {
          if (res.error_code === 10000) {
            this.data = res.data.data
            this.page = res.data.current_page
            this.pageSize = res.data.per_page
            this.total = res.data.total
          }
        })
      },
      look(src) {
        this.$alert(`<img src="${src}">`, '', {
          dangerouslyUseHTMLString: true,
        })
      },
      _del(id, key) {
        this.$request(`member/${id}`, '', 'delete').then((res) => {
          if (res.error_code === 10000) {
            this.data.splice(key, 1)
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          }
        })
      },
      handle_page(e) {
        this.page = e
        this._request()
      },
      //  删除
      del(id, key) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this._del(id, key)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      },
      open_stop(status, id, key) {
        let title = status ? '停用' : '启用'
        this.$confirm(`此操作将该${title}医生小程序账号, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
          center: true,
        })
          .then(() => {
            this.$request(
              `member/${id}`,
              { status: status ? 0 : 1 },
              'PUT'
            ).then((res) => {
              if (res.error_code === 10000) {
                this.$message.success(res.msg)
                this.data[key]['status'] = !status
              } else {
                this.$message.error(res.msg)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      },
      // 修改
      openEdit(id) {
        this.$store.commit('set_id', id)
        this.$store.commit('add_tabs', {
          path: 'edit-admin',
          name: '编辑医生',
        })
      },
      _password(id, text) {
        this.$request(`/member/${id}`, { password: text }, 'PUT').then(
          (res) => {
            if (res.error_code === 10000) {
              this.$message.success(res.msg)
            } else {
              this.$message.error(res.msg)
            }
          }
        )
      },
      _change(id, text) {
        this.$confirm('此操作将修改密码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
          center: true,
        })
          .then(() => {
            this._password(id, text)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      },
      change(id) {
        this.$alert(``, `修改密码`, {
          dangerouslyUseHTMLString: true,
          showInput: true,
          inputPlaceholder: '请输入新密码',
          confirmButtonText: '确认修改',
        }).then((e) => {
          if (e.action === 'confirm') {
            this._change(id, e.value)
          }
        })
      },
      create() {
        this.$store.commit('add_tabs', {
          path: 'add-admin',
          name: '添加医生',
        })
      },
      next(e) {
        this.page = e
        this._request()
      },
    },
  }
</script>

<style scoped></style>
